var _path, _rect, _rect2, _use, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _g2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g3, _g4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbNir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gb-nir",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    fillRule: "evenodd",
    rx: 0,
    ry: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 512,
    height: 102.4,
    y: 204.8,
    fill: "#c00",
    fillRule: "evenodd",
    rx: 0,
    ry: 0
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 600,
    height: 300,
    transform: "matrix(0 1 -.9375 0 496 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M291.2 156.4c3-5.2 1.2-8.5-3.4-9.5 0 0-14.9 5-31 5.6-16 .6-35-4.3-35-4.3-3.5 2.3-2.7 7.8-1 11.2 0 0 16.8 5.9 36 5.3a108 108 0 0 0 30.1-5.8c3.7-1.3 4.3-2.5 4.3-2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#161111",
    strokeWidth: 1.6,
    d: "m320 389.6-30.9-64.2-70.9 5.4 40-58.8-40-58.8 71 5.4 30.8-64.1 30.9 64 70.9-5.3-40 58.8 40 58.8-71-5.4z",
    transform: "matrix(1 0 0 1.06667 -64 -34.1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#b02320",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.4,
    d: "M255.5 130.4c38.8 6.8 37.4 8.7 37.4 8.7L303 107s1.1-6.4-1.7-10.3-10.5-1.7-10.5-1.7-1-5.2-4.5-6.4c-3.4-1.3-16 4.9-20 6.2-4 1.4-6 2.7-11.5 2.6a52.1 52.1 0 0 1-17.3-6.3 15 15 0 0 0-6.9-2c-2.4.1-5 .8-6.3 2.6-1.2 1.9-1.2 4.1-1.2 4.1s-2-1.3-5.3-1.3c-3.2 0-5 .4-6.5 2.2-1.4 1.9-3.4 7-3.4 7l3.7 8.7.2 12 7.5 12.8 36.2-6.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebeae3",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M291.7 148.6s2 2.5 1.9 3.4c-.1.8-1 1.6-1 1.6s.7.7.5 1.7c-.1 1-1.4 1-1.4 1s.3.9-.5 1.3-3.8 1-3.8 1-15-4.5-31-4.5-35 5.6-35 5.6-2-.8-2-2.1c-.2-1.4.1-2.4.1-2.4s-1 .2-1.3-.8c-.4-1.4.1-2.5.1-2.5s-.7.2.1-1.6a4 4 0 0 1 1.5-1.9s16.8-6.4 36-6.4a101 101 0 0 1 35.8 6.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M212.2 108.3s-.6-2.4.8-4.4a4.1 4.1 0 0 1 4.7-1.5c.8.4.7 1.3 1.7 1.6 1 .3 1.8-.5 1.8-.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillOpacity: 0.9,
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m305.8 113.7-5.8 12.8-2.3.5s-1.4-1-5.4-.6c-2.8.2-3.7 1-3.7 1l5.2-12.8s.4 2.7 1 4.3c.8 2 3.7 4 3.7 4s.4-2.4-.4-5.4c-.8-3.3-2.8-7.8-2.8-7.8l10.5 4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#121116",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M252.5 73.8h6.5v29.5h-6.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    d: "m212.6 128.3 4.1 9.5s17.9-7.4 38.9-7.3c31.5.2 40.5 7 40.5 7l4.6-11.8-3.5 2.1-3.6 2.4-4 1.7-5-.4-4.4-3.5-2.2-5-3.7 3.7-6.6 1.6-6.4-1.8-5.6-7.6s-4.2 8.4-9.6 9c-7.7.7-12.1-4-12.1-4s-2.9 6.8-7.6 8c-7.5 2-13.7-3.6-13.8-3.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 59.9 -67.6)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M279.5 71.9s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.1-.8 1.4-1.7 1.7-.6.1-1.6-.1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 51.7 -63.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M271.3 76s2.8 0 3-1.3c.3-1.1-.2-2.7-.2-2.7s1.3 1.6 1 2.7c-.4 1.2-.8 1.5-1.7 1.8-.6.1-1.6-.1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 69.3 -70)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M289 69.5s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.1-.8 1.5-1.7 1.7a3 3 0 0 1-2.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 80 -67.7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M299.7 71.8s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.1-.8 1.5-1.7 1.7-.7.2-1.6-.1-2.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 88.2 -60.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M307.9 79s2.7 0 3-1.3c.2-1.2-.2-2.7-.2-2.7s1.3 1.5.9 2.7c-.4 1.2-.7 1.5-1.7 1.7-.6.2-1.5 0-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 91.7 -48.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M311.4 90.7s2.7 0 3-1.2c.2-1.2-.2-2.7-.2-2.7s1.3 1.5.9 2.7c-.4 1.2-.7 1.5-1.7 1.7-.6.2-1.5-.1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 90.4 -36.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M310 102.6s2.8 0 3-1.2c.3-1.2-.1-2.7-.1-2.7s1.3 1.5.9 2.7c-.4 1.1-.7 1.5-1.7 1.7-.6.1-1.5-.1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 85.5 -26.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M305.1 113s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.2-.8 1.5-1.7 1.7-.6.2-1.6 0-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 43.7 -60.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M263.4 79.1s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.1-.8 1.4-1.7 1.7a3 3 0 0 1-2.1-.5z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.43616 0 0 .46523 70.3 -38.8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M254 77.9s2.3 0 2.5-1c.3-1-.1-2.3-.1-2.3s1 1.2.8 2.2c-.4 1-.7 1.3-1.4 1.5a2.3 2.3 0 0 1-1.8-.4z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.43616 0 0 .46523 70.4 -35)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M254 81.6s2.3 0 2.6-1c.2-1-.2-2.2-.2-2.2s1 1.2.8 2.2c-.3 1-.6 1.3-1.4 1.5a2.3 2.3 0 0 1-1.7-.4z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.43616 0 0 .46523 70.6 -29.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M254.3 87.2s2.2 0 2.5-1c.2-1-.2-2.3-.2-2.3s1 1.3.8 2.3c-.3 1-.6 1.2-1.4 1.4a2.3 2.3 0 0 1-1.7-.4z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.47168 0 0 .50313 55.5 -33)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M254.2 93.3s2.5-.1 2.7-1.2c.3-1-.1-2.4-.1-2.4s1.1 1.4.8 2.4c-.4 1.1-.7 1.4-1.5 1.6a2.5 2.5 0 0 1-1.9-.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 34.4 -38.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M254 101.3s2.8 0 3-1.2c.3-1.2-.1-2.7-.1-2.7s1.3 1.5.9 2.7c-.4 1.2-.7 1.5-1.7 1.7-.6.2-1.5 0-2-.5z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.48982 0 0 .52248 47.7 -13.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M254 117.5s2.6 0 2.8-1.1c.3-1.2-.1-2.6-.1-2.6s1.2 1.4.8 2.5c-.3 1.2-.7 1.4-1.5 1.7a2.6 2.6 0 0 1-2-.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 25 -60.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M244.6 79s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.1-.8 1.5-1.7 1.7-.6.1-1.6-.1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 16.6 -64)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M236.3 75.5s2.7 0 3-1.2c.2-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.5 1.1-.8 1.4-1.8 1.7-.6.1-1.5-.1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 8.6 -68)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M228.3 71.5s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.1-.8 1.4-1.7 1.7a3 3 0 0 1-2.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 -.5 -70.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M219.1 69.3s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.2-.8 1.5-1.7 1.7-.6.2-1.6 0-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 -11.4 -67.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M208.3 72.1s2.7 0 3-1.2c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.2-.8 1.5-1.7 1.7-.7.2-1.6-.1-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 -19 -59.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M200.7 80.3s2.7-.1 3-1.3c.2-1.2-.2-2.7-.2-2.7s1.3 1.5.9 2.7c-.4 1.2-.7 1.5-1.7 1.7-.6.2-1.5 0-2-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 -22.2 -47.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M197.5 91.7s2.7 0 3-1.3c.3-1.2-.2-2.7-.2-2.7s1.3 1.5 1 2.7c-.4 1.2-.8 1.5-1.7 1.7-.7.2-1.6 0-2.1-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 -20.8 -36)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M198.9 103.6s2.7 0 3-1.3c.3-1.1-.2-2.7-.2-2.7s1.3 1.6 1 2.7c-.4 1.2-.8 1.5-1.7 1.8a3 3 0 0 1-2.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.52155 0 0 .55632 -15.6 -25.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M204 114.3s2.8 0 3-1.2c.3-1.2-.1-2.7-.1-2.7s1.3 1.5 1 2.7c-.5 1.2-.8 1.5-1.8 1.7-.6.2-1.5 0-2-.5z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.31597 -.0903 .13499 .53737 45.4 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M212.3 128.7s1.6-.5 1.5-1.7c0-1.2-.7-2.6-.7-2.6s1.1 1.3 1.2 2.5c0 1.2-.1 1.5-.6 2-.3.2-1 .1-1.4-.2z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.31758 .08362 -.125 .54011 196 -42.9)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M298.3 127.8s1.7.4 2.1-.7c.5-1.1.5-2.7.5-2.7s.5 1.7 0 2.8-.8 1.3-1.4 1.4c-.4 0-1-.4-1.2-.8z"
  })))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#b3a192",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m252.7 57.4.3 6s-6.8.7-7 1.4c-1.4 3.1 1.5 7.3 1.5 7.3s2.3-1.8 8-1.8c5.5 0 8.3 1.5 8.3 1.5s1.4-2.5 1.4-4.3c0-1.8-.6-3.6-.6-3.6l-3.6-.4h-2.5l-.2-6.2-5.6.1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0ddcb",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M262.4 66.8c0 .7-.6 1.3-1.2 1.3a1.2 1.2 0 0 1-1.3-1.3 1.2 1.2 0 0 1 1.2-1.2 1.2 1.2 0 0 1 1.3 1.2m2.7.7c0 .7-.5 1.3-1.2 1.3s-1.3-.6-1.3-1.3a1.3 1.3 0 0 1 1.3-1.3c.7 0 1.2.6 1.2 1.3m-5.5-.7c0 .7-.6 1.2-1.2 1.2-.7 0-1.2-.5-1.2-1.2a1.2 1.2 0 0 1 1.1-1.3 1.2 1.2 0 0 1 1.3 1.3m-5.6 0c0 .8-.6 1.3-1.3 1.3-.7 0-1.2-.5-1.2-1.2 0-.8.5-1.3 1.2-1.3s1.3.5 1.3 1.2m-3.1.3c0 .7-.6 1.3-1.3 1.3s-1.2-.6-1.2-1.3c0-.7.5-1.3 1.2-1.3s1.3.6 1.3 1.3m5.7-3.7c0 .6-.5 1-1 1a1 1 0 0 1-1.1-1 1 1 0 0 1 1-1.1 1 1 0 0 1 1 1m0-5c0 .6-.4 1-1 1a1 1 0 0 1-1-1 1 1 0 0 1 1-1 1 1 0 0 1 1 1m0 2.7c0 .6-.4 1.1-1 1.1a1 1 0 0 1-1-1 1 1 0 0 1 1-1.2 1 1 0 0 1 1 1.1m-8.8 7c0 .7-.5 1.2-1.2 1.2-.6 0-1.2-.5-1.2-1.2a1.2 1.2 0 0 1 1.2-1.3 1.2 1.2 0 0 1 1.2 1.3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#916c68",
    stroke: "#4d3126",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M256.9 66.5c0 .8-.6 1.4-1.4 1.4a1.4 1.4 0 0 1-1.3-1.4 1.4 1.4 0 0 1 1.3-1.3 1.4 1.4 0 0 1 1.4 1.3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#1e1e1e",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M430.6 247.4a6.5 6.5 0 0 1-6.4 6.5 6.5 6.5 0 0 1-6.5-6.5 6.5 6.5 0 0 1 6.4-6.5 6.5 6.5 0 0 1 6.5 6.5",
    transform: "matrix(.386 0 0 .41173 91.8 -53.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3afb8",
    fillRule: "evenodd",
    d: "M254.4 49.9s2 0 2.2-1c.2-.8-.1-2-.1-2s1 1.2.7 2c-.3 1-.6 1.2-1.2 1.3a2 2 0 0 1-1.6-.3z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M216 138.8s2.2 2.2 2.8 4.2c.6 2 1.5 7.3 1.5 7.3s23.2-7 34.6-6.4c11.4.6 37.7 6.8 37.7 6.8l1-6.2c.5-3.2 2.7-6.6 2.7-6.6s-25.2-8.4-41-7.6c-15.9.8-23.8 2.6-27.3 3.8a248.5 248.5 0 0 0-12 4.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M250.7 38.5h10s-2.5 1.8-3 3.5c-.4 1.5-.3 4-.3 4s2.7 0 4-1.1l3.7-3v13.5s-2.5-2.5-4-3.4c-1.7-1-3.5-1.3-3.5-1.3s0 2.2.8 3.5l4.3 6.2-14.3.6s3.4-3.8 4.7-6.6c1-1.8.6-3.7.6-3.7s-2.4 0-3.6.9c-1.3.9-3.4 3.6-3.4 3.6v-13s1 2.5 3 3.4c2 1 3.8.5 3.8.5s.4-2.6-.4-4.2c-.9-1.7-2.6-3.5-2.4-3.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.2,
    d: "M249.9 81.5s-7.1 0-13.2-3.9c-6.1-3.8-12.3-7.8-21.3-5.6-1.8.5-8.7 3.7-11.7 14-2 7.3.4 16 2.5 20 2.2 3.9 5.6 7.9 5.6 7.9l3.7-2.7s-9.4-8.4-8.2-19.4c1-11 6.2-13.5 6.2-13.5s6.4-5.3 14.9-.3a76.8 76.8 0 0 0 25.3 9.2c.6 0-4-5.7-3.8-5.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m210.5 122.7-3.8-8 11.4-4.7s-2.8 4-3.4 6.7c-.8 3.4-.5 6.3-.5 6.3s1-.9 2.3-3c1-1.8 2.6-7.9 2.6-7.9l5.1 17.4s-2.6-2.8-4.5-3.1c-2-.4-4.6.3-4.6.3l-3 1-1.6-5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#121116",
    strokeWidth: 1.2,
    d: "M262.7 81.4s7.1 0 13.2-4c6.1-3.8 12.2-7.8 21.3-5.5 1.8.5 8.6 3.6 11.6 14 2.1 7.2-.3 16-2.5 20l-3.6 6.2-4.4-1.7s8.1-7.8 7-18.8c-1.1-11-6.2-13.5-6.2-13.5s-6.4-5.3-14.9-.3-16.8 7.3-16.8 7.3-7.8 2-8.5 2c-.7-.1 4-5.8 3.8-5.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M259 73.9h3v29.5h-3zm-10-.1h3.5v29.5H249z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    stroke: "#121116",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M265.2 66.9a9.6 9.6 0 0 1-9.7 9.5 9.6 9.6 0 0 1-9.7-9.5 9.6 9.6 0 0 1 9.6-9.5 9.6 9.6 0 0 1 9.8 9.4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    fillRule: "evenodd",
    stroke: "#000",
    d: "m246.9 103.2 16.7-.1s-2 1.2-3.6 4.4c-1.7 3.2-1.5 5.2-1.5 5.2s2.6 0 4.3-1.5c1.8-1.3 3.8-4 3.8-4v16.5s-1.3-2.1-3.3-3.4c-2-1.2-4.8-1.2-4.8-1.2h-5.7s-2.6.2-3.7 1a29.9 29.9 0 0 0-3.7 3.4L245 108s.8 2.7 3.5 3.8 4.2 1 4.2 1 0-3.5-1.4-5.3-4.5-4.2-4.5-4.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6ca1f",
    fillRule: "evenodd",
    stroke: "#000",
    d: "M256.2 116s2.4 6.1 5.3 8.8c1.6 1.6 6.6 2.8 8.8 2.2 5-1.4 8.6-5.7 8.6-5.7s-.2 4.7 3 7.3c3.1 2.6 5.6 3.3 8.2 2.5 2.7-.8 10-6.6 10-6.6l1.6 1.4s-4.3 4.4-8.7 6.7c-2.3 1.2-9.3.6-11.5-1.4-2.3-1.9-3.6-6.5-3.6-6.5s-1.4 3-4.4 4c-3 1-7 1-10.9-.2-2.5-.8-5.9-4.5-6.5-5.8-.6-1.2-.4-2-.4-2s-2 5.8-5.8 7.4a17.6 17.6 0 0 1-11.5.4c-3.6-1.1-3.9-3.3-3.9-3.3s-.2 6-8 7.8c-8 1.8-14.2-4.4-14.2-4.4l1.1-1.7s4.4 5.3 11.2 4.8c6.8-.5 9-9.8 9-9.8s3 4.9 11 5c7.9 0 10.2-11 10.2-11l1.4.2z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M338.6 336.3s0-5.3 1.2-6.9a4.6 4.6 0 0 1 5-2c1.3.4 2.8 1.6 2.5 5.3-.2 3.7-1.2 5.5-.1 6.9 1 1.4 1.2 2.3 3.4 2 2-.3 3-1 2.5-3-.4-2-1 .2-1.5-1.5-.4-1.6 2.1-8.7 1.7-13.1-.4-4.3-2-7.8-5.3-8.6-3.1-.8-5.8-.8-8.7 1.3a35 35 0 0 0-6.3 8.7v14.3l5.7-.4-.1-3z",
    transform: "matrix(.52155 0 0 .55632 60 -67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M327.8 340.1s-2.3-4.8-4-5.8a4.7 4.7 0 0 0-5.3.1c-1 1-1.9 2.6-.2 6 1.7 3.2 3.3 4.5 2.9 6.2-.5 1.7-.2 2.6-2.3 3.2s-3.2.3-3.6-1.7c-.3-2 1.1-.3.8-2-.3-1.6-5.4-7.2-6.7-11.4-1.4-4-1.3-8 1.4-10 2.5-2 5-3 8.4-2.2 3.4.7 9.3 5.4 9.3 5.4l5.8 13-5.5 2-1-2.8z",
    transform: "matrix(.52155 0 0 .55632 60 -67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M326.7 297.9s-5.7 9.5-4.4 16.8c1.2 7.3 8.8 23 8.8 23v2l4-.4-.8-2.2s2-18.7.7-24.6c-.9-4.4-8.3-14.5-8.3-14.6zm9 43.4s2.8 3.4 6.2 5c3.6 1.8 5.2 1.8 6.6.7 1-.8.7-4.2-.5-5.2-1.3-.9-2.7-.4-3 .5-.3 1.6-.8 1.5-2 .9l-5.5-3.3-1.8 1.4zm-4.4.8s-1.2 4.2-3.6 7c-2.6 3.2-4 3.9-5.8 3.5-1.3-.3-2.3-3.6-1.6-5 .8-1.4 2.3-1.5 2.8-.7 1 1.2 1.5 1 2.3 0a149.1 149.1 0 0 0 3.7-5.4l2.2.6z",
    transform: "matrix(.52155 0 0 .55632 60 -67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.1 342c0 1.2-4 2.2-8.8 2.2s-8.9-1-9-2.3c0-1.2 4-2.2 8.9-2.2s8.9 1 8.9 2.2",
    transform: "matrix(.51436 -.09206 .0863 .54866 33 -35.2)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M338.6 336.3s0-5.3 1.2-6.9a4.6 4.6 0 0 1 5-2c1.3.4 2.8 1.6 2.5 5.3-.2 3.7-1.2 5.5-.1 6.9 1 1.4 1.2 2.3 3.4 2 2-.3 3-1 2.5-3-.4-2-1 .2-1.5-1.5-.4-1.6 2.1-8.7 1.7-13.1-.4-4.3-2-7.8-5.3-8.6-3.1-.8-5.8-.8-8.7 1.3a35 35 0 0 0-6.3 8.7v14.3l5.7-.4-.1-3z",
    transform: "matrix(.48843 .1951 -.1829 .521 177.8 -120.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M327.8 340.1s-2.3-4.8-4-5.8a4.7 4.7 0 0 0-5.3.1c-1 1-1.9 2.6-.2 6 1.7 3.2 3.3 4.5 2.9 6.2-.5 1.7-.2 2.6-2.3 3.2s-3.2.3-3.6-1.7c-.3-2 1.1-.3.8-2-.3-1.6-5.4-7.2-6.7-11.4-1.4-4-1.3-8 1.4-10 2.5-2 5-3 8.4-2.2 3.4.7 9.3 5.4 9.3 5.4l5.8 13-5.5 2-1-2.8z",
    transform: "matrix(.48843 .1951 -.1829 .521 177.8 -120.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M326.7 297.9s-5.7 9.5-4.4 16.8c1.2 7.3 8.8 23 8.8 23v2l4-.4-.8-2.2s2-18.7.7-24.6c-.9-4.4-8.3-14.5-8.3-14.6zm9 43.4s2.8 3.4 6.2 5c3.6 1.8 5.2 1.8 6.6.7 1-.8.7-4.2-.5-5.2-1.3-.9-2.7-.4-3 .5-.3 1.6-.8 1.5-2 .9l-5.5-3.3-1.8 1.4zm-4.4.8s-1.2 4.2-3.6 7c-2.6 3.2-4 3.9-5.8 3.5-1.3-.3-2.3-3.6-1.6-5 .8-1.4 2.3-1.5 2.8-.7 1 1.2 1.5 1 2.3 0a149.1 149.1 0 0 0 3.7-5.4l2.2.6z",
    transform: "matrix(.48843 .1951 -.1829 .521 177.8 -120.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M342.1 342c0 1.2-4 2.2-8.8 2.2s-8.9-1-9-2.3c0-1.2 4-2.2 8.9-2.2s8.9 1 8.9 2.2",
    transform: "matrix(.51196 .1062 -.09955 .5461 141.8 -100.3)"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#cca715",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M215 138.5s.6 2.2 1.8 1c1.1-1 17.2-7.8 39.8-7.8s37.6 6.6 38.5 7c.9.4 1.3 1 2 0 .8-.9-.7-2.4-.7-2.4s-15.8-7.1-40.4-7c-24.7 0-40.6 7.6-40.6 7.6s-1 .8-.3 1.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M243.8 148.6s.8-2.2 2-2.6c1-.3 2.6.8 2.6.8s-1.9-.2-2.5.1c-.5.4-.7 1.3-.7 1.3s.4-.7 1.9-.7l1.6.1s-2.5.2-3 1c-.6.7 2.3 1 2.3 1s-4.5.1-5-.2c-.7-.3-1-1.2-2-1-1 .4-2 1.3-2 1.3s1-2 1.8-2c.7 0 1.1 0 1.8.2s1.2.7 1.2.7zm-16.7 3.9s.3-2.3 1.5-3c1-.5 2.7.3 2.7.3s-2 .1-2.5.6c-.4.5-.4 1.4-.4 1.4s.2-.8 1.7-1l1.6-.3s-2.4.7-2.8 1.6c-.5.9 2.5.6 2.5.6s-4.4 1-5 .8c-.7-.2-1.2-1-2.2-.6-.9.5-1.7 1.6-1.7 1.6s.8-2.2 1.5-2.4c.7-.1 1-.2 1.8 0 .7.1 1.3.4 1.3.4zm30.9-4.7s.8-2.1 2-2.4c1.1-.3 2.6.8 2.6.8s-1.9-.2-2.5 0c-.5.4-.8 1.3-.8 1.3s.5-.7 2-.5l1.6.1s-2.5 0-3.1.8c-.6.7 2.3 1.3 2.3 1.3s-4.5-.3-5-.6c-.6-.3-1-1.3-2-1.1-1 .2-2 1.1-2 1.1s1.2-2 1.9-2c.7.1 1.1.1 1.8.5l1.2.7zm14.1 1.7s1-2 2.4-2.1c1-.2 2.4 1.1 2.4 1.1s-1.8-.5-2.5-.3c-.6.3-.9 1.2-.9 1.2s.5-.7 2-.3l1.6.3s-2.5-.2-3.2.4c-.7.7 2.1 1.6 2.1 1.6s-4.4-.8-5-1.2c-.4-.4-.7-1.5-1.7-1.4-1 .1-2.2 1-2.2 1s1.5-1.9 2.2-1.8c.7.1 1.1.2 1.7.6l1.1.9zm14 2.7s1-1.5 2.1-1.6c.9 0 1.9 1.2 1.9 1.2s-1.5-.6-2-.4c-.5 0-.8.8-.8.8s.5-.5 1.6-.1l1.3.4s-2-.4-2.6 0c-.6.5 1.6 1.5 1.6 1.5s-3.5-1-4-1.4c-.3-.3-.4-1.2-1.2-1.2-.9 0-1.9.6-1.9.6s1.3-1.4 1.9-1.2c.5.1.9.2 1.3.6l.9.8z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f6545",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M241 138.4c.4 1.8-1.6 3.7-4.4 4.3-2.7.6-5.3-.4-5.6-2.2-.3-1.8 1.6-3.7 4.4-4.3 2.8-.6 5.3.4 5.6 2.2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecfc1",
    d: "M234.8 138c0 .5-.4 1-1 1.1-.6.1-1.2-.1-1.3-.5 0-.5.4-1 1-1 .6-.2 1.2 0 1.3.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f6545",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.7,
    d: "M280.1 140.5c-.5 1.8-3 2.5-5.8 1.6-2.7-1-4.4-3-4-4.8.6-1.8 3.2-2.5 5.9-1.6 2.7 1 4.5 3 4 4.8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecfc1",
    d: "M274.8 137c-.2.5-.7.7-1.3.5-.6-.2-1-.7-.9-1.2.1-.4.7-.6 1.3-.4.6.2 1 .7.9 1.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#1f2d86",
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M250.6 134.3h10.1v5.5h-10.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#707c8b",
    d: "M254.9 135.5c0 .3-.5.5-1 .5s-1-.3-1-.5.5-.4 1-.4 1 .2 1 .4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "m222 139.8 1.6 5.3-3 1.8s-1.5 1-3 .2c-1.3-.8-2.2-3.2-1.4-4.2 1.5-2 5.7-3.2 5.7-3.1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#8f322f",
    d: "M219.3 143.6c0 .8-.6 1.6-1.4 1.6s-1.4-.8-1.4-1.6c0-1 .6-1.7 1.4-1.7s1.4.8 1.4 1.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a494",
    d: "M218 143a1 1 0 0 1-.2.6c-.1.2-.3.2-.5.1-.2 0-.3-.3-.4-.6a1 1 0 0 1 .2-.7.4.4 0 0 1 .5-.1c.2 0 .4.3.4.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9f1209",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.5,
    d: "m289.9 140.5-1.7 4.7 4 2.2s1.7.8 2.8-.2c1-.9 1.2-3 .4-4-.7-1-5.6-2.7-5.5-2.7z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#aa675d",
    d: "M294.6 144.3c0 .5-.6 1-1.3 1s-1.2-.5-1.2-1c0-.6.6-1.1 1.2-1.1.7 0 1.3.5 1.3 1z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e2a494",
    d: "M293.4 144c0 .4-.1.6-.3.8a.5.5 0 0 1-.6 0 .8.8 0 0 1-.3-.7c0-.3.1-.5.3-.7a.5.5 0 0 1 .6 0c.2.2.3.4.3.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5d8bc",
    d: "M264.6 134.8a.7.7 0 0 1-.8.7.7.7 0 0 1-.7-.7.7.7 0 0 1 .7-.7.7.7 0 0 1 .8.7zm4.3.3a.7.7 0 0 1-.7.7.7.7 0 0 1-.8-.7.7.7 0 0 1 .8-.7.7.7 0 0 1 .7.7zm-2.2 1.8a.9.9 0 0 1-1 .9.9.9 0 0 1-.8-1c0-.4.4-.8.9-.8s.9.4.9.9zm2 3a.7.7 0 0 1-.6.7.7.7 0 0 1-.8-.7.7.7 0 0 1 .7-.8.7.7 0 0 1 .8.8zm-4.1-.6a.7.7 0 0 1-.7.7.7.7 0 0 1-.7-.7.7.7 0 0 1 .7-.7.7.7 0 0 1 .7.7zm-20.9-3.7a.7.7 0 0 1-.5.9.7.7 0 0 1-.9-.6.7.7 0 0 1 .6-.8.7.7 0 0 1 .8.5zm4.3-.8a.7.7 0 0 1-.6.9.7.7 0 0 1-.8-.5.7.7 0 0 1 .5-1 .7.7 0 0 1 .9.6zm-1.8 2.3a1 1 0 0 1-.6 1 .9.9 0 0 1-1.1-.6 1 1 0 0 1 .7-1 .9.9 0 0 1 1 .6zm2.7 2.4a.7.7 0 0 1-.5.9.7.7 0 0 1-.9-.5.7.7 0 0 1 .5-1 .7.7 0 0 1 .9.6zm-4.2.5a.7.7 0 0 1-.5.8.7.7 0 0 1-.9-.5.7.7 0 0 1 .6-.9.7.7 0 0 1 .8.6zm-19.2-.2a.8.8 0 0 1-.4 1 .7.7 0 0 1-.9-.5.8.8 0 0 1 .4-1 .7.7 0 0 1 1 .5zm4.1-1.4a.8.8 0 0 1-.4 1 .7.7 0 0 1-.9-.5.8.8 0 0 1 .4-1 .7.7 0 0 1 1 .5zm-1.4 2.5a1 1 0 0 1-.5 1.2.9.9 0 0 1-1.2-.5 1 1 0 0 1 .6-1.2.9.9 0 0 1 1.1.5zm3 2a.8.8 0 0 1-.4 1 .7.7 0 0 1-1-.5.8.8 0 0 1 .5-1 .7.7 0 0 1 .9.5zm-4.1 1a.8.8 0 0 1-.4 1 .7.7 0 0 1-1-.4.8.8 0 0 1 .5-1 .7.7 0 0 1 .9.4zm56.2-6.2a.8.8 0 0 1-1 .5.8.8 0 0 1-.5-1 .8.8 0 0 1 1-.5.8.8 0 0 1 .5 1zm4.4 1.4a.8.8 0 0 1-.9.6.8.8 0 0 1-.6-1 .8.8 0 0 1 1-.5.8.8 0 0 1 .5 1zm-2.7 1.3a1 1 0 0 1-1.1.7 1 1 0 0 1-.8-1.2 1 1 0 0 1 1.2-.7c.5.1.8.7.7 1.2zm1.5 3.7a.8.8 0 0 1-1 .6.8.8 0 0 1-.5-1 .8.8 0 0 1 .9-.5.8.8 0 0 1 .6 1zm-4.3-1.7a.8.8 0 0 1-.9.5.8.8 0 0 1-.5-1 .8.8 0 0 1 .9-.5.8.8 0 0 1 .5 1z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M292 94.9s-2 2-4.5 2a7 7 0 0 1-4.6-1.6c-.8-.6.2-2.2.2-2.2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1,
    d: "M248.9 99s-3.7-.7-5.3-1.3c-1.5-.5-1.1-1.6-3-1.5-1.7.2-3.5 1.5-3.1 3.4.4 2 1.7 2.2 3 1.8 1.2-.4.8-2.7-.8-2.6-1.7.2-.3 1.7-.3 1.7M223.3 96s1 1.6 3.7 1.3c2.7-.2 3.7-1.8 3.8-2.4.1-.7 0-2-.5-2.5s-2.3-.8-2.3-.8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#161111"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M312 169c1.6-1.5 4-3.2 5.4-6.9 1.3-3.5 2-9.8 3.2-13 1.5-5.5 4.6-10.8 1-10.5-3.6.4-4.8 3.8-6.1 6.3-.6 1-2 3-2.3 4 0-1.8-1-7.4-1.2-13-.2-5.2 0-10.6-.2-12.6-.2-2.7-.2-5.2-.8-7.2-.3-1-1.6-1.8-2.3-1.8-1.5 0-2.3 1.3-2.5 2.5l-.2 1.7-.1 5.2v5.6l-.5 7.2c0-1.3-.6-7.3-.8-13a419.5 419.5 0 0 1-.2-6.3l-.1-4.6c-.3-2.2-1-3.1-2.5-3.1-1 0-2.6.7-3 3.1a21.5 21.5 0 0 0-.3 4.6l.1 5c-.1 6.5-.2 13.5-.5 15.5 0-.7-.7-4.1-.8-8.7a804.7 804.7 0 0 0-.3-6l-.2-6c0-1-.4-3.9-2.3-3.7-1-.1-2.1.6-2.5 3.3-.3 1.5-.3 4.1-.3 6.1 0 3.9-.2 7.2 0 10.6v4.8c0 .3-.5-1.8-.8-4.6l-.5-5.4c0-1.4 0-3.5-.2-5.3 0-1.3 0-2.8-1.5-2.7-1.5.1-2.4.6-2.7 3.2-.2 1.6-.3 5.2-.3 6.5a88 88 0 0 1-1.1 13.2c-.1 1.6-.8 3.6-1 5.8a44 44 0 0 0 .6 12.9c1.2 4.4 4.4 6.4 4.2 9.4v10.6c0 2.4 2 2.5 6.3 1.6 7-1.5 10.8 1.5 16.5-.7-.7-6.6.7-10.5.7-12.9zm-4-15.4c1.4-4 3.2-5.6 5-6.4",
    transform: "matrix(1.6 0 0 1.70667 -224 0)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M292.1 149.5c2.2-.9 4.4-1.5 6.6-2.3 2.8-.7 5.4-1.8 8.1-2.2 1.4-.3 2.7-.6 4-.7m-22.5 26.3c.3-.2.6.2.9.2.4.1.8.3 1.2.2a66.9 66.9 0 0 1 2.6 0c1 0 1.8 0 2.6-.6m6.3.3c.3.3.6.5 1 .6.5.2 1 .3 4.6 0 2.1.1 4-1.7 4.6-2.3",
    transform: "matrix(1.6 0 0 1.70667 -224 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbNir);
export default __webpack_public_path__ + "static/media/gb-nir.93fdc2318cb5cc7f68eaaa25e77dff2f.svg";
export { ForwardRef as ReactComponent };